import { render, staticRenderFns } from "./transfer.vue?vue&type=template&id=653e3817&scoped=true&"
import script from "./transfer.vue?vue&type=script&lang=js&"
export * from "./transfer.vue?vue&type=script&lang=js&"
import style0 from "./transfer.vue?vue&type=style&index=0&id=653e3817&prod&scoped=true&lang=css&"
import style1 from "./transfer.vue?vue&type=style&index=1&id=653e3817&prod&lang=css&"
import style2 from "./transfer.vue?vue&type=style&index=2&id=653e3817&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653e3817",
  null
  
)

export default component.exports